module.exports = __webpack_public_path__ + "c667c4a7.svg";